// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';

import { SkeletonProvider } from 'react-skeletonify';
import { handleVitePreloadError } from './utils/chunkLoadRecovery';

window.addEventListener('vite:preloadError', handleVitePreloadError);

import './index.css';
import '../src/styles/common.css';
import 'react-skeletonify/dist/index.css';

import './dev-error-bridge'; // runtime error logger & console overrides
import App from './App';

import { DevErrorBoundary } from './dev-error-bridge'; // React error boundary

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <DevErrorBoundary>
      <SkeletonProvider
        config={{
          animation: 'animation-1',
          animationSpeed: 3,
          background: '#eee',
          border: 'none',
          borderRadius: '8px',
          textTagsMargin: '0',
        }}
      >
        <App />
      </SkeletonProvider>
    </DevErrorBoundary>
  </React.StrictMode>,
);
